import React, { useEffect, useLayoutEffect } from "react";
import About from "../LegacyCode/About";
import HomepageTeamNew from "../Homepage/TeamComponent/HomepageTeamNew";
import MetaDecorator from "../../util/MetaDecorator";

const AboutusPage = () => {
  useLayoutEffect(() => {
    // Scroll to top when component mounts - useLayoutEffect runs before paint
    // The scrollable container is the .main-content Box in App.js
    const scrollContainer = document.querySelector('.main-content');
    if (scrollContainer) {
      scrollContainer.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);
  
  useEffect(() => {
    // Also scroll after a brief delay to ensure it works
    const timer = setTimeout(() => {
      const scrollContainer = document.querySelector('.main-content');
      if (scrollContainer) {
        scrollContainer.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return (
    <div>
      <MetaDecorator
        title="Autogenbots - About"
        description=" A STARTUP THAT SEEKS TO PROVIDE ROBOTICS MOBILITY SOLUTIONS TO ACCELERATE
      BUSINESS DEVELOPMENT THROUGH ROBOTIC LABOUR FORCE"
      />
      <About />
      <HomepageTeamNew />
    </div>
  );
};

export default AboutusPage;
